// extracted by mini-css-extract-plugin
export default {"wrapper":"sidebarErrorBoundary_wrapper__l02w0"};